import { enumToOptions } from '@libs/types/src/common/enum/util';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';

export enum ServiceOperationalCapacityUnitEnum {
    // HealthCare
    CONTINOUS_OPERATION_WORK_SCHEDULE = 'continousOperationWorkSchedule',
    IMMEDIATE_BED_AVAILABILITY = 'immediateBedAvailability',
    IMMEDIATE_ROOM_AVAILABILITY = 'immediateRoomAvailability',

    // Social
    BEDS = 'beds',
    ROOMS_FLAT = 'roomsFlat',
    WORKERS_DAY = 'workersDay',
    WORKERS_IMMEDIATE = 'workersImmediate',
    CLIENTS_DAY = 'clientsDay',
    CLIENTS_IMMEDIATE = 'clientsImmediate',
    SERVICE_HOURS = 'serviceHours',
}

export const healthCareTypes = [
    ServiceOperationalCapacityUnitEnum.CONTINOUS_OPERATION_WORK_SCHEDULE,
    ServiceOperationalCapacityUnitEnum.IMMEDIATE_BED_AVAILABILITY,
    ServiceOperationalCapacityUnitEnum.IMMEDIATE_ROOM_AVAILABILITY,
];

export const socialTypes = [
    ServiceOperationalCapacityUnitEnum.BEDS,
    ServiceOperationalCapacityUnitEnum.ROOMS_FLAT,
    ServiceOperationalCapacityUnitEnum.WORKERS_DAY,
    ServiceOperationalCapacityUnitEnum.WORKERS_IMMEDIATE,
    ServiceOperationalCapacityUnitEnum.CLIENTS_DAY,
    ServiceOperationalCapacityUnitEnum.CLIENTS_IMMEDIATE,
    ServiceOperationalCapacityUnitEnum.SERVICE_HOURS,
];

export const serviceOperationalCapacityUnitEnumOptions = enumToOptions(ServiceOperationalCapacityUnitEnum, 'service.settings.general.operationalCapacity.units.');

export function serviceOperationalCapacityUnitEnumOptionsByType(serviceType?: string | null) {
    let allowed: string[] = [];
    switch (serviceType) {
        case ServiceTypeEnum.HEALTH_CARE:
            allowed = healthCareTypes;
            break;
        case ServiceTypeEnum.SOCIAL:
            allowed = socialTypes;
            break;
    }

    return serviceOperationalCapacityUnitEnumOptions
        .filter((it) => allowed.includes(it.value as any))
        ;
}
